import { render, staticRenderFns } from "./PageEdit.vue?vue&type=template&id=66313b28&scoped=true&"
import script from "./PageEdit.vue?vue&type=script&lang=ts&"
export * from "./PageEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66313b28",
  null
  
)

export default component.exports